import axios from 'axios';
import { LOGIN_REQUEST, LOGIN_SUCCESS, LOGIN_FAILURE, SET_USER_FROM_STORAGE, LOGOUT } from '../../types/login/loginTypes';

export const login = (credentials, navigate) => async (dispatch) => {
  dispatch({ type: LOGIN_REQUEST });
  try {
    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
    const API_URL = `${API_BASE_URL}/api/auth/login`;
    const res = await axios.post(`${API_URL}`, credentials, {
      withCredentials: true
    });
    
    // Debug: Log the response data
    console.log('Login response:', res.data);
    console.log('User data from response:', res.data.user);
    
    // Store user data in localStorage for persistence
    localStorage.setItem('userData', JSON.stringify(res.data.user));
    
    dispatch({ type: LOGIN_SUCCESS, payload: res.data.user });
  } catch (error) {
    console.error('Login Error:', error.message);
    if (!error.response) {
      dispatch({ type: LOGIN_FAILURE, payload: 'Could not connect server' });
    } else if (error.response.status === 401 || error.response.status === 400) {
      dispatch({ type: LOGIN_FAILURE, payload: 'Invalid Login Credential' });
    } else {
      dispatch({ type: LOGIN_FAILURE, payload: error.response.data?.message || 'Login failed. Please try again.' });
    }
  }
};

export const logout = () => dispatch => {
  localStorage.removeItem('userData');
  dispatch({ type: LOGOUT });
};

// Action to set user from localStorage (for page refresh persistence)
export const setUserFromStorage = (userData) => ({
  type: SET_USER_FROM_STORAGE,
  payload: userData,
});

// Action to check and restore user from localStorage
export const checkAuthStatus = () => (dispatch) => {
  dispatch({ type: 'AUTH_CHECK_START' });
  try {
    const userData = localStorage.getItem('userData');
    if (userData) {
      const parsedUserData = JSON.parse(userData);
      dispatch(setUserFromStorage(parsedUserData));
    }
  } catch (error) {
    localStorage.removeItem('userData');
  }
  dispatch({ type: 'AUTH_CHECK_END' });
};